export const CERTIFICATE_STATUS__PENDING = 'PENDING';
export const CERTIFICATE_STATUS__SECURE = 'SECURE';
export const CERTIFICATE_STATUS__INSECURE = 'INSECURE';
